import LanguageIcon from "@mui/icons-material/Language";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link } from "react-router-dom";

const Participation = () => {
  return (
    <section
      id="participation"
      className="py-12 px-6 border-b-0 border-0 md:px-12 bg-[#DAF4F1] xs:py-16 text-brandBlue font-outfit text-center"
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl xs:text-2xl xxs:text-2xl font-bold text-center mb-4">
          Participation & Registration
        </h2>

        <p className="mb-8 text-lg xs:text-base xxs:text-base text-[#4C7C7D] leading-relaxed">
          Participation is open via invitation and registration, with a
          selection process ensuring a balanced mix of government, academia, and
          civil society
        </p>
        <Link
          to="/register"
          className="mb-10 inline-block bg-brandGreen text-brandBlue text-lg font-bold py-3 px-10 rounded-xl hover:bg-brandGreen hover:text-white transition-all"
        >
          Register Now
        </Link>
        <div className="gradient-divider" />

        <div className="mt-14 grid gap-4 sm:grid-cols-4 text-left justify-center sm:text-center">
          <div className="flex text-brandBlue items-center gap-3 justify-start group">
            <LanguageIcon className="text-brandGreen transition-transform duration-300 group-hover:scale-110 group-hover:opacity-80" />
            <a
              href="https://www.igcg.info"
              className="hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.igcg.info
            </a>
          </div>
          <div className="flex items-center gap-3 justify-start group">
            <EmailIcon className="text-brandGreen transition-transform duration-300 group-hover:scale-110 group-hover:opacity-80" />
            <a href="mailto:info@igcg.net" className="hover:underline">
              info@igcg.net
            </a>
          </div>
          <div className="flex items-center gap-3 justify-start group">
            <LinkedInIcon className="text-brandGreen transition-transform duration-300 group-hover:scale-110 group-hover:opacity-80" />
            <a
              href="https://www.linkedin.com/company/igcg"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              LinkedIn
            </a>
          </div>
          <div className="flex items-center gap-3 justify-start group">
            <PhoneIcon className="text-brandGreen transition-transform duration-300 group-hover:scale-110 group-hover:opacity-80" />
            <span>+383 (0) 45 540 164</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Participation;
